import { defineStore } from 'pinia'
import req from '@/api/httpRequest'

export const useUserSettingsStore = defineStore('userSettings', () => {
  const userAvatarUrl = ref(null)
  const userDetails = ref({})

  const PROD = 'https://dispatcher.r1.robstor.com'
  let permanentAvatarURL = ''

  async function fetchUserSettings() {
    const { data } = await req.post('user/info', {
      headers: {},
      requestParam: {},
    })

    if (data.data) {
      userAvatarUrl.value = `${PROD}${data.data.avatar}`
      permanentAvatarURL = `${PROD}${data.data.avatar}`
      userDetails.value = data.data
    }
  }

  async function uploadUserAvatar(file) {
    const formData = new FormData()
    formData.append('file', file)

    const { data } = await req.post('user/setavatar', {
      headers: { 'Content-Type': 'multipart/form-data' },
      requestParam: formData,
    })

    if (data) {
      userAvatarUrl.value = `${permanentAvatarURL}?timestamp=${Date.now()}`
    }
  }

  return {
    userAvatarUrl,
    userDetails,
    fetchUserSettings,
    uploadUserAvatar,
  }
})
